import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import RsTableHeaderSortControl from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderSortControl';
import RsTableHeaderLabel from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderLabel';
import Button from '@Components/Button';
import { Button as LButton } from '@els/els-react--button';
import { TooltipConstants } from '@Components/Tooltip';
import { useHistory } from 'react-router-dom';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import HoverTooltip from '@Components/HoverTooltip';
import { isAnyPredictiveRetrosynthesisAvailable } from '../../predictiveUtils';

import './ProjectTableHeader.theme.scss';

function ProjectTableHeader({ className, sort, onSortChange, onToggleParamsDisplay, showParams = false }) {
  const history = useHistory();
  return (
    <tr className={className}>
      <th>
        <RsTableHeaderLabel />
      </th>
      <th className="no">
        <RsTableHeaderSortControl sortList={sort} sortParam="id" onChange={onSortChange}>
          No.
        </RsTableHeaderSortControl>
      </th>
      <th>
        <RsTableHeaderSortControl sortList={sort} sortParam="modified" onChange={onSortChange}>
          Date
        </RsTableHeaderSortControl>
      </th>
      <th>
        <RsTableHeaderSortControl sortList={sort} sortParam="name" onChange={onSortChange}>
          Project name
        </RsTableHeaderSortControl>
      </th>
      <th>
        <RsTableHeaderLabel>
          <div className={`${className}__draw-structure-container`}>
            <span className="plus">+</span>
            <Button
              buttonConfig={{
                className: 'draw-structure',
                type: 'secondary',
                size: 'sm',
                e2eName: 'draw-structure-header',
              }}
              iconConfig={{ name: 'draw-structure', size: 'lg' }}
              onClick={() => history.push(RsRoute.DRAW_STRUCTURE)}>
              Draw new <br /> structure
            </Button>
          </div>
        </RsTableHeaderLabel>
      </th>
      <th className={cn('params', !showParams && 'params--collapsed', 'interactive')}>
        <RsTableHeaderLabel
          sublabels={showParams && isAnyPredictiveRetrosynthesisAvailable() ? ['Predicted parameters', 'Published parameters'] : null}>
          <HoverTooltip
            id={TooltipConstants.ids.Retrosynthesis}
            tag="div"
            place="bottom"
            tooltip={`${showParams ? 'Close' : 'Show'} parameters`}
            theme="simple"
            className="toggle-project-params-tooltip u-els-font-size-base">
            <LButton
              aria-label={`${showParams ? 'Close' : 'Show'} parameters`}
              type="tertiary"
              onClick={onToggleParamsDisplay}
              size="x-small"
              className="params__toggle-btn-i">
              <svg className="els-btn-icon els-btn-icon-tiny">
                <use xlinkHref={showParams ? '#icon-chevron-right' : '#icon-chevron-left'} />
              </svg>
            </LButton>
          </HoverTooltip>
          {!showParams || isAnyPredictiveRetrosynthesisAvailable() ? null : 'Parameters'}
        </RsTableHeaderLabel>
      </th>
      <th>
        <RsTableHeaderLabel>No. of routes</RsTableHeaderLabel>
      </th>
    </tr>
  );
}

ProjectTableHeader.defaultProps = {
  onToggleParamsDisplay: () => {},
};

ProjectTableHeader.propTypes = {
  sort: PropTypes.array,
  // sortProperty: PropTypes.func,
  showParams: PropTypes.bool,
  onToggleParamsDisplay: PropTypes.func,
  className: PropTypes.string,
  onSortChange: PropTypes.func,
};

export default ProjectTableHeader;
